import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Button, styled, Typography } from '@mui/material';
import { ReactComponent as PlaidDealpumpIcon } from '@/assets/images/plaid-dealpump.svg';
import { ReactComponent as LogoDealpumpItalic } from '@/assets/images/dealpump-italic.svg';
import { ReactComponent as LockIcon } from '@/assets/images/lock.svg';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
  height: '100%',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.secondary.light,
}));

const LogoContainer = styled(Box)(() => ({
  display: 'flex',
  alignSelf: 'center',
  justifyContent: 'center',
  paddingTop: 40,
  paddingBottom: 44,
}));

const Card = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing(2),
  boxSizing: 'border-box',
  padding: theme.spacing(2),
  paddingLeft: '24px',
  paddingRight: '24px',
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  marginTop: '23px',
}));

export default function PlaidFailedPage() {
  const navigate = useNavigate();

  const handleTryAgain = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Container>
      <Grid
        container
        direction="column"
        height="100%"
        maxWidth="600px"
        wrap="nowrap"
        justifyContent="space-between"
      >
        <Grid item xs={12}>
          <Grid container flexDirection="column" flexWrap="nowrap" gap={2}>
            <Grid item xs={12}>
              <LogoContainer>
                <LogoDealpumpItalic width={90} height={20} />
              </LogoContainer>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h2"
                fontWeight={700}
                fontSize={48}
                textAlign="center"
                lineHeight={'48px'}
              >
                Ooops!
              </Typography>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                textAlign="center"
                lineHeight={'20px'}
                color="#4E4F52"
                sx={{ mt: 1 }}
              >
                Sometimes bank logins time out. Let’s try again – your rewards are waiting!
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <PlaidDealpumpIcon />
                <Typography variant="body2" textAlign="center" lineHeight={'18px'}>
                  Findies uses Plaid to connect to your bank account. Your personal information is
                  never sold. To disconnect, visit Plaid directly.
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginBottom: 1 }}>
          <Typography
            variant="body2"
            lineHeight={'18px'}
            sx={{ display: 'flex', justifyContent: 'center', gap: 1, alignItems: 'center' }}
          >
            <LockIcon /> Connection powered by Plaid
          </Typography>
          <Button variant="contained" size="large" onClick={handleTryAgain}>
            Retry & unlock wallet
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
